import "../styles/Login.css";
import { Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/images/SMS2ublue.svg";
import React, { useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "../api/axiosInstance";

const Login = ({ setAuth }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("All fields are required");
      return;
    }

    setLoading(true);

    try {
      const response = await axiosInstance.post("/auth/login", {
        email,
        password,
      });

      const { data } = response;

      if (data) {
        localStorage.setItem(
          "auth",
          JSON.stringify({
            token: data.token,
            user: data.data,
          })
        );
        navigate("/");
        setAuth({
          token: data.token,
          user: data.data,
        });
        toast.success(data.message);
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message || "Invalid credentials!");
      } else if (error.request) {
        toast.error("No response from server. Please try again later.");
      } else {
        toast.error("An error occurred. Please try again.");
      }
      console.error("🚀 -> handleLogin -> error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="loginPage">
        <div className="contianer-fluid g-0 w-100">
          <div className="row align-items-stretch w-100 g-0">
            <div className="col-lg-6 col-12 g-0">
              <div className="loginBox">
                <div className="logoBox text-center">
                  <Link to="/">
                    <img alt="logo" src={Logo} height={200} />
                  </Link>
                </div>
                <div className="loginFormBox">
                  <Form className="pb-5" onSubmit={handleLogin}>
                    <Form.Group className="mb-4 ">
                      <Form.Control
                        autoComplete="off"
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        type="email"
                        value={email}
                      />
                    </Form.Group>
                    <Form.Group className="mb-4 ">
                      <Form.Control
                        autoComplete="off"
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        type="password"
                        value={password}
                      />
                    </Form.Group>
                    <div className="text-center mb-5">
                      <button
                        className="primaryBtn w-100 mb-2"
                        disabled={loading}
                        type="submit"
                      >
                        {loading ? "Logging in..." : "Login"}
                      </button>
                      <Link className="forgoetpass" to="">
                        Forget Your Password?
                      </Link>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12 d-lg-block d-none"></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
